<template>
  <v-list-item class="px-2" dense :class="item.IsActive ? '' : 'deactivated'" style="width: calc(100%)"
    @click="$emit('click')">
    <v-list-item-avatar tile class="my-auto mr-2">
      <ArticleImage :size="48" :articleNumber="item.ArticleNumber" :relativePath="item.ArticleImage"
        :timeType="item.Type">
      </ArticleImage>
    </v-list-item-avatar>

    <v-list-item-content :style="showStoreItems && item.IsStoreArticle ? 'max-width: calc(100% - 170px);' : ''">
      <v-list-item-title>
        {{ item.ArticleNumber }}
      </v-list-item-title>
      <v-list-item-subtitle>
        {{ item.ArticleDescription }}
      </v-list-item-subtitle>
    </v-list-item-content>

    <template v-if="showStoreItems && !item.Internal && item.IsStoreArticle">
      <v-divider vertical></v-divider>
      <StockIndicator :StoreItems="item.StoreItems">
      </StockIndicator>
    </template>
  </v-list-item>
</template>


<script>
import ArticleImage from "@/views/pim/articles/ArticleImage.vue";
import StockIndicator from "./StockIndicator.vue";

export default {
  name: 'ArticleListItem2',
  props: {
    item: Object,
    showStoreItems: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    StockIndicator,
    ArticleImage,
  },

  data() {
    return {
    };
  },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'>
.deactivated {
  background-color: var(--v-disabled-lighten1) !important;
}

.deactivated:not(:hover) div div {
  color: var(--v-disabled-darken2) !important;
  text-decoration: line-through !important;
}
</style>